import { render, staticRenderFns } from "./simCancelRecord.vue?vue&type=template&id=4f647ed4&scoped=true&"
import script from "./simCancelRecord.vue?vue&type=script&lang=js&"
export * from "./simCancelRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f647ed4",
  null
  
)

export default component.exports